import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnimatedText from 'components/common/AnimatedText';

class InlineCollapsible extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			placeholding: false,
			plain: props.plain || props.children,
		}
	}
	toggle = (e) => {
		if ( !this.state.open ) {
			this.setState({ open: !this.state.open, placeholding: true });
		} else {
			this.setState({ placeholding: true });
			setTimeout( () => { this.setState({ open: false }) } );
		}
		if ( this.props.ontoggle ) this.props.ontoggle( !this.state.open );
	}
	onTransitionEnd = () => {
		this.setState({placeholding: false});
		if ( this.props.onTransitionEnd) this.props.onTransitionEnd();
	}
	render() {
		let triggerClassName = "InlineCollapsible__trigger ";
		triggerClassName += (this.state.open)? 'is-open' : 'is-closed';

		const usePlaceHolder = this.state.placeholding || !this.state.open;

		return (
			<span className="InlineCollapsible">
				<span className={triggerClassName} onClick={this.toggle}>{this.props.trigger}</span>
				<span className="InlineCollapsible__content">
					{ usePlaceHolder && 
						<AnimatedText 
							transitionTime={this.props.transitionTime} 
							open={this.state.open} 
							onTransitionEnd={this.onTransitionEnd}>
							{this.state.plain}
						</AnimatedText>
					}
					{ !usePlaceHolder && this.props.children }
				</span>
			</span>
		)
	}
}

InlineCollapsible.propTypes = {
	plain: PropTypes.string,
	trigger: PropTypes.string,
	onTransitionEnd: PropTypes.func,
}

export default InlineCollapsible;


// WEBPACK FOOTER //
// ./src/components/common/InlineCollapsible.jsx